import React, { useEffect } from "react";
import { Page, Document, StyleSheet, Image } from "@react-pdf/renderer";
import avatar from '../../../images/avatar/1.jpg'
import icon from "../../../images/adhaan-icon.png";
import logo from '../../../images/adhaan-full-logo.png'
import title from "../../../images/adhaan-title.png";
import InvoiceTitle from "./InvoiceTitle";
import InvoiceNo from "./InvoiceNo";
import BillTo from "./BillTo";
import InvoiceThankYouMsg from "./InvoiceThankYouMsg";
import InvoiceItemsTable from "./InvoiceItemsTable";
import { useLocation } from "react-router-dom";

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#fff',
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft: 50,
        paddingRight: 50,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    logo: {
        width: 100,
        height: 70,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
});

const PdfDocument = ({ invoicedata }) => {

    return (
        <Document>
            <Page size="A4" style={styles.page} >
                <InvoiceTitle items={invoicedata} />
                <InvoiceItemsTable invoice={invoicedata} />
                <InvoiceThankYouMsg />
            </Page>
        </Document>
    );
}

export default PdfDocument;